import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@app/shared/services/auth.service';
import { environment } from '@env/environment';

declare let google: any;
declare let window: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

  loading = false;
  loggingErr = false;
  mappedData;
  private unsubscribe$ = new Subject<void>();
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
   }

  ngOnInit() {
   }


   ngAfterViewInit() {
    this.promptSignIn();
  }


  promptSignIn(){
    google.accounts.id.initialize({
      client_id: environment.googleClientId,
      ux_mode: 'popup',
      cancel_on_tap_outside: false,
      callback: ({ credential }) => {
        this.ngZone.run(() => {
          this.loading = true;
          this._loginWithGoogle(credential);
        });
      },
    });
    
    const signInDiv: HTMLElement = document.getElementById('g_signin_div');
    window.google.accounts.id.renderButton(signInDiv, {
      type: 'standard',
      shape: 'pill',
      theme: 'outline',
      text: 'continue_with',
      size: 'large',
      logo_alignment: 'left',
      width: 250
    })
  }


  _loginWithGoogle(token: string) {
    this.authService.handleOnTapeSignIn(token);
    this.loading = false;
  }


  public signIn() {
    google.accounts.id.prompt();
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
    });
}


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
